export default function addScriptUtil(src) {
  const s = document.createElement('script');
  s.setAttribute('src', src);
  s.setAttribute('async', 'true');
  document.head.appendChild(s);
}
